/**
 * grapht — deployed as continuum-grapht (.io). Base, with the customer's
 * name on the tab; no pages or routes of its own yet.
 */
import type { CustomerProfile } from "@/customer/profile";
import { pagesByName } from "@/customer/profile";
import type { PageModule } from "@/page-dsl/spec";

const profile: CustomerProfile = {
  id: "grapht",
  name: "Continuum — grapht",
  nav: { items: [] },
  pages: pagesByName(import.meta.glob<PageModule>("./pages/*.page.ts")),
};

export default profile;
